angular.module('impactx.list').directive('ixListDeprecatedFilter', function(){
    return {
        restrict: 'E',
        scope: {
            field: '=',
            suffix: '@'
        },
        require: '^stTable',
        template: '</md-input-container><md-checkbox ng-model="field.selected" ng-change="change()">{{suffix}}</md-checkbox>',
        link: function (scope, element, attr, ctrl) {
            scope.change = function change () {
                ctrl.search(scope.field.selected, scope.field.filterField);
            };
            if (scope.field.selected)
            {
                ctrl.search(scope.field.selected, scope.field.filterField);
            }
        }
    }
});
